import React,{useEffect} from 'react'
import '../../styles/preisrechner.css'
import * as formUtils from './Helpers/FormHelper'

const Contact = props => {

  const initializeDynamicComponent = () =>
  {
    let actual_JSON = props.actualJson;
    let chosenIndex = props.service;
    document.getElementsByClassName("vermHeading")[0].innerHTML = "Kontakt";

    document.querySelectorAll('.vermInputHorizontal')[0].innerHTML = "";
    actual_JSON.Contact.forEach((item,index) => {
      if (item.viewtype == 1 || item.viewtype == 5 || item.viewtype == 6){
        document.querySelectorAll('.vermInputHorizontal')[0].appendChild(formUtils.createTextBox(props.setDataFromId,item.title,item.type,item.viewtype,true));
      }
      if (item.viewtype == 2){
        document.querySelectorAll('.vermInputHorizontal')[0].appendChild(formUtils.createDatePicker(props.setDataFromId,item.title,item.type,item.viewtype,true));
      }
      if (item.viewtype == 3){
        document.querySelectorAll('.vermInputHorizontal')[0].appendChild(formUtils.createRadioButtons(props.setData,item.title,item.values,item.type,index,item.viewtype));
      }
    });
    if (props.storage() != null){
      props.storage().forEach(x => document.getElementById(x.type.toString()).value = x.value);
    }
  }

  useEffect(() => {
    initializeDynamicComponent();
  });

  return (
  <div className="step">
      <div className="vermFormContent">

        <div className="vermLeftContent"></div>
        <div className="vermCenterContent">
          <div className="vermHeading">
          </div>
          <div className="vermInputHorizontal">
            
          </div>
        </div>
        <div className="vermRightSide">
          <div className="vermRightContent">
            <div className="vermHeading headRight">
              Höhenaufnahme
            </div>
            <ul className="vernRightList">
              <p>Durch die wiederholende Messungen der gleichen Überwachugnspunkte werden allfällige
                Bewegungen festgehalten. Dieser Verschiebungen werden aufbereitet und in Plänte und
                Tabellen visualisiert.</p>
            </ul>

            <div className="vernDownload">
              <div className="rightdivider"></div>
              <p>Beispielsdaten <br /> herunterladen </p>
              <div className="downloadLinkGrp">
                <img width="12" src="./assets/arrow-down.svg"/>
                <a className="downloadLink" href="#">Höhenaufnahme.pdf</a>
              </div>
              <div>
                <img width="12" src="./assets/arrow-down.svg"/>
                <a className="downloadLink" href="#">Höhenaufnahme.dwg</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact